import { generateRandomId } from "../../../utils/session";
import BLOCK_TYPES from "./block.types";
import CONFIG from "../../../config/config";

export const ActionPalette = [
    {
        group: "Interactions",
        enabled: true,
        items: [
            { name: "Bot response", id: BLOCK_TYPES.BOT_RESPONSE },
            { name: "Yapay Zeka Cevap", id: BLOCK_TYPES.AI_BOT_RESPONSE, disabled: !CONFIG.CHATBOT.GPT3_ENABLED },
            {
                name: "Fallback",
                id: BLOCK_TYPES.FALLBACK,
            },
            {
                name: "Timeout",
                id: BLOCK_TYPES.TIMEOUT,
            },
            { name: "Filter", id: BLOCK_TYPES.FILTER },
            {
                name: "Flow",
                id: BLOCK_TYPES.FLOW,
            },
            { name: "Attachment Input", id: BLOCK_TYPES.ATTACHMENT_INPUT },
            {
                name: "User Input",
                id: BLOCK_TYPES.USER_INPUT,
            },
            {
                name: "AI Classification",
                id: BLOCK_TYPES.AI_CLASSIFICATION,
            },
            {
                name: "Feedback AI Assistant",
                id: BLOCK_TYPES.FEEDBACK_AI_ASSISTANT,
            },
            {
                name: "Insert To System Prompt",
                id: BLOCK_TYPES.INSERT_TO_SYSTEM_PROMPT,
            },
            {
                name: "Web Search (Tavily)",
                id: BLOCK_TYPES.TAVILY_WEB_SEARCH,
            },
            {
                name: "Web Search (OpenAI)",
                id: BLOCK_TYPES.OPENAI_WEB_SEARCH,
            },
            {
                name: "AI Call",
                id: BLOCK_TYPES.AI_CALL,
            },
        ],
    },
    {
        group: "Actions",
        enabled: true,
        items: [
            { name: "Go To Step", id: BLOCK_TYPES.GO_TO_STEP },
            { name: "Add To Segment", id: BLOCK_TYPES.ADD_TO_SEGMENT },
            { name: "Remove From Segment", id: BLOCK_TYPES.REMOVE_FROM_SEGMENT },
            {
                name: "Webhook",
                id: BLOCK_TYPES.WEBHOOK,
            },
            { name: "API Request", id: BLOCK_TYPES.API_REQUEST },
            { name: "Set Attribute", id: BLOCK_TYPES.SET_ATTRIBUTE },
            {
                name: "Question",
                id: BLOCK_TYPES.QUESTION,
            },
            { name: "Close Chat", id: BLOCK_TYPES.CLOSE_CHAT },
            { name: "Get Location", id: BLOCK_TYPES.GET_LOCATION },
            { name: "Run JavaScript", id: BLOCK_TYPES.RUN_JAVASCRIPT },
        ],
    },
    {
        group: "Supsis Actions",
        enabled: true,
        items: [
            { name: "Assign Owner", id: BLOCK_TYPES.ASSIGN_OWNER },
            { name: "Create Ticket", id: BLOCK_TYPES.CREATE_TICKET },
            {
                name: "Transfer Chat",
                id: BLOCK_TYPES.TRANSFER_CHAT,
            },
            {
                name: "Forward to ChatBot",
                id: BLOCK_TYPES.TRANSFER_TO_CHATBOT,
            },
            { name: "Add Tag", id: BLOCK_TYPES.TAG_CHAT },
            { name: "Remove Tag", id: BLOCK_TYPES.REMOVE_TAG },
            { name: "Set Department", id: BLOCK_TYPES.SET_DEPARTMENT },
            {
                name: "Question",
                id: BLOCK_TYPES.QUESTION,
            },
            { name: "Close Chat", id: BLOCK_TYPES.CLOSE_CHAT },
            {
                name: "Send Transcript",
                id: BLOCK_TYPES.SEND_TRANSCRIPT,
            },
            {
                name: "Send SMS",
                id: BLOCK_TYPES.SEND_SMS,
            },
            {
                name: "Send Mail",
                id: BLOCK_TYPES.SEND_MAIL,
            },
            {
                name: "Create Event",
                id: BLOCK_TYPES.CREATE_EVENT,
            },
            {
                name: "Create Task",
                id: BLOCK_TYPES.CREATE_TASK,
            },
            {
                name: "Ban Visitor",
                id: BLOCK_TYPES.SUPPRESSION_ADD,
            },
            {
                name: "Unban Visitor",
                id: BLOCK_TYPES.SUPPRESSION_REMOVE,
            },
            {
                name: "Create Reservation",
                id: BLOCK_TYPES.CREATE_RESERVATION,
            },
            {
                name: "Select Reservation Day",
                id: BLOCK_TYPES.RESERVATION_SELECT_DAY,
            },
            {
                name: "Select Reservation Time",
                id: BLOCK_TYPES.RESERVATION_SELECT_TIME,
            },
            {
                name: "Reservation Open Url",
                id: BLOCK_TYPES.RESERVATION_OPEN_URL,
            },
            {
                name: "Reservation List Visitor",
                id: BLOCK_TYPES.RESERVATION_EVENT_LIST,
            },
            {
                name: "Send Whatsapp Business Message",
                id: BLOCK_TYPES.SEND_WP_BUSINESS_MESSAGE,
            },
        ],
    },
    {
        group: "Table Actions",
        enabled: true,
        items: [
            { name: "Create Record", id: BLOCK_TYPES.TABLE_CREATE_RECORD },
            { name: "Delete Record", id: BLOCK_TYPES.TABLE_DELETE_RECORD },
            { name: "Update Record", id: BLOCK_TYPES.TABLE_UPDATE_RECORD },
            { name: "Find Record", id: BLOCK_TYPES.TABLE_FIND_RECORD },
            { name: "Find Records", id: BLOCK_TYPES.TABLE_FIND_RECORDS },
        ],
    },
    {
        group: "Cache Actions",
        enabled: true,
        items: [
            { name: "Cache Write", id: BLOCK_TYPES.CACHE_WRITE },
            { name: "Cache Read", id: BLOCK_TYPES.CACHE_READ },
            { name: "Cache Extend", id: BLOCK_TYPES.CACHE_EXTEND },
            { name: "Cache Delete", id: BLOCK_TYPES.CACHE_DELETE },
        ],
    },
    {
        group: "Templates",
        enabled: true,
        items: [
            { name: "AI MENU FLOW", id: BLOCK_TYPES.AI_MENU_FLOW },
            { name: "OTP MAIL FLOW", id: BLOCK_TYPES.OTP_MAIL_FLOW },
            { name: "OTP SMS FLOW", id: BLOCK_TYPES.OTP_SMS_FLOW },
            { name: "OTP WHATSAPP FLOW", id: BLOCK_TYPES.OTP_WHATSAPP_FLOW },
            { name: "AI INSTAGRAM FLOW", id: BLOCK_TYPES.AI_INSTAGRAM_FLOW },
            { name: "PLATFORM FLOW", id: BLOCK_TYPES.PLATFORM_FLOW },
        ],
    },
    {
        group: "Meta Actions",
        enabled: true,
        items: [
            { name: "Instagram Reply Message", id: BLOCK_TYPES.INSTAGRAM_COMMENT_REPLY },
            { name: "Instagram Delete Message", id: BLOCK_TYPES.INSTAGRAM_COMMENT_DELETE },
            { name: "Instagram Show Message", id: BLOCK_TYPES.INSTAGRAM_COMMENT_SHOW },
            { name: "Instagram Hide Message", id: BLOCK_TYPES.INSTAGRAM_COMMENT_HIDE },
            { name: "Instagram Reply as Private", id: BLOCK_TYPES.INSTAGRAM_COMMENT_REPLY_AS_PRIVATE },
            { name: "Messenger Send Message", id: BLOCK_TYPES.MESSENGER_SEND_MESSAGE },
            { name: "Instagram Send Message", id: BLOCK_TYPES.INSTAGRAM_SEND_MESSAGE },
            { name: "Send CAPI Event", id: BLOCK_TYPES.META_SEND_CAPI_EVENT },
        ],
    },
    // {
    //     group: "Shopify Actions",
    //     enabled: true,
    //     items: [
    //         { name: "Show Products", id: BLOCK_TYPES.SHOPIFY_SHOW_PRODUCTS },
    //         {
    //             name: "Product Availability",
    //             id: BLOCK_TYPES.SHOPIFY_PRODUCT_AVAILABILITY,
    //         },
    //         { name: "Order Status", id: BLOCK_TYPES.SHOPIFY_ORDER_STATUS },
    //     ],
    // },
    {
        group: "Akinon Actions",
        enabled: CONFIG.AKINON.enabled,
        items: [
            { name: "Order Status", id: BLOCK_TYPES.AKINON_ORDER_STATUS },
            { name: "Select Order", id: BLOCK_TYPES.AKINON_SELECT_ORDER },
            { name: "Show Stocks", id: BLOCK_TYPES.AKINON_FIND_NEAREST_STOCK },
            { name: "Select Size", id: BLOCK_TYPES.AKINON_SELECT_SIZE },
            { name: "Find Product", id: BLOCK_TYPES.AKINON_FIND_PRODUCT },
            { name: "Show Discount Codes", id: BLOCK_TYPES.AKINON_SHOW_DISCOUNT_CODES },
            { name: "Nearest Stores", id: BLOCK_TYPES.AKINON_FIND_NEAREST_STORES },
        ],
    },
    {
        group: "IdeaSoft Actions",
        enabled: true,
        items: [
            { name: "Select Order", id: BLOCK_TYPES.IDEASOFT_SELECT_ORDER },
            { name: "Order Status", id: BLOCK_TYPES.IDEASOFT_ORDER_STATUS },
            { name: "Get Member Info", id: BLOCK_TYPES.IDEASOFT_GET_MEMBER_INFO },
            { name: "Product Search", id: BLOCK_TYPES.IDEASOFT_PRODUCT_SEARCH },
        ],
    },
    {
        group: "T-Soft Actions",
        enabled: true,
        items: [
            { name: "Order Status", id: BLOCK_TYPES.TSOFT_ORDER_STATUS },
            { name: "Select Order", id: BLOCK_TYPES.TSOFT_SELECT_ORDER },
        ],
    },
    {
        group: "Ticimax-V2 Actions",
        enabled: true,
        items: [
            { name: "Order Status", id: BLOCK_TYPES.TICIMAX_V2_ORDER_STATUS },
            { name: "Select Order", id: BLOCK_TYPES.TICIMAX_V2_SELECT_ORDER },
        ],
    },
    {
        group: "Ikas Actions",
        enabled: true,
        items: [
            { name: "Get Member Info", id: BLOCK_TYPES.IKAS_GET_MEMBER_INFO },
            { name: "Select Order", id: BLOCK_TYPES.IKAS_SELECT_ORDER },
            { name: "Order Status", id: BLOCK_TYPES.IKAS_ORDER_STATUS },
        ],
    },
    {
        group: "Probel Actions",
        enabled: CONFIG.PROBEL.enabled,
        items: [
            { name: "Select Branch", id: BLOCK_TYPES.PROBEL_SELECT_BRANCH },
            { name: "Select PolyClinic", id: BLOCK_TYPES.PROBEL_SELECT_CLINIC },
            { name: "Select Date", id: BLOCK_TYPES.PROBEL_SELECT_DAY },
            { name: "Select Hour", id: BLOCK_TYPES.PROBEL_SELECT_HOUR },
            { name: "Make Appointment", id: BLOCK_TYPES.PROBEL_MAKE_APPOINTMENT },
            { name: "Cancel Appointment", id: BLOCK_TYPES.PROBEL_CANCEL_APPOINTMENT },
            { name: "Patient Token", id: BLOCK_TYPES.PROBEL_GET_PATIENT_TOKEN },
            { name: "Fill Info", id: BLOCK_TYPES.PROBEL_FILL_INFO },
            { name: "Select Appointment", id: BLOCK_TYPES.PROBEL_SELECT_APPOINTMENT },
        ],
    },
    {
        group: "B2Cargo Actions",
        enabled: CONFIG.B2CARGO.enabled,
        items: [
            { name: "Login User", id: BLOCK_TYPES.B2CARGO_LOGIN_USER },
            { name: "Order Status", id: BLOCK_TYPES.B2CARGO_PRODUCT_STATUS },
        ],
    },

    {
        group: "Holiday Plus Actions",
        enabled: CONFIG.HOLIDAY_PLUS.enabled,
        items: [
            { name: "Get Hotels", id: BLOCK_TYPES.HOLIDAY_PLUS_GET_HOTELS },
            { name: "Get Rooms", id: BLOCK_TYPES.HOLIDAY_PLUS_GET_ROOMS },
        ],
    },
    {
        group: "Zoho Actions",
        enabled: true,
        items: [{ name: "Create Record", id: BLOCK_TYPES.ZOHO_CREATE_RECORD }],
    },
];

export const BlockStyles = {
    START_POINT: { color: "#fff", backgroundColor: "#566e8a" },
    AI_ASSISTANT: { color: "#fff", background: "linear-gradient(162deg,#4b6ae5,#0031f6)" },
    FEEDBACK_AI_ASSISTANT: { color: "#fff", background: "linear-gradient(162deg,#4b6ae5,#0031f6)" },
    INSERT_TO_SYSTEM_PROMPT: { color: "#fff", background: "linear-gradient(162deg,#6a4be5,#3100f6)" },
    DEFAULT_FALLBACK: { color: "#fff", backgroundColor: "#797b8c" },
    DEFAULT_TIMEOUT: { color: "#fff", backgroundColor: "#d2ba69" },
    AI_CALL: { color: "#fff", backgroundColor: "rgb(35 35 35 / 84%)" },
    AI_FUNCTIONS: { color: "#fff", backgroundColor: "#f30879" },
    BOT_RESPONSE: { color: "#647283", backgroundColor: "#f5f5f5" },
    AI_BOT_RESPONSE: { color: "#647283", backgroundColor: "#41ce13" },
    AI_CLASSIFICATION: { color: "#647283", backgroundColor: "#41ce13" },
    FALLBACK: { color: "#ffffff", backgroundColor: "#797b8c" },
    TIMEOUT: { color: "#fff", backgroundColor: "#d2ba69" },
    FILTER: { color: "#fff", backgroundColor: "#686ad3" },
    FLOW: { color: "#000", backgroundColor: "#b3d6ff" },
    ATTACHMENT_INPUT: { color: "#647283", backgroundColor: "#E7E4E4" },
    USER_INPUT: { color: "#59687b", backgroundColor: "#c9d3de" },
    GO_TO_STEP: { color: "#000", backgroundColor: "#ffdc67" },
    ADD_TO_SEGMENT: { color: "#22314A", backgroundColor: "#9CCB80" },
    REMOVE_FROM_SEGMENT: { color: "#22314A", backgroundColor: "#F5F5F5" },
    WEBHOOK: { color: "#fff", backgroundColor: "#40455b" },
    API_REQUEST: { color: "#fff", backgroundColor: "#40455b" },
    SET_ATTRIBUTE: { color: "#fff", backgroundColor: "#6e5b8c" },
    ASSIGN_OWNER: { color: "#fff", backgroundColor: "#6e5b8c" },
    QUESTION: { color: "#000", backgroundColor: "#ffad5c" },
    CLOSE_CHAT: { color: "#000", backgroundColor: "#f5f5f5" },
    CREATE_TICKET: { color: "#ffffff", backgroundColor: "#AD6FE9" },
    TRANSFER_TO_CHATBOT: { color: "#ffffff", backgroundColor: "#ff00ca" },
    TRANSFER_CHAT: { color: "#000", backgroundColor: "#76E394" },
    TAG_CHAT: { color: "#000", backgroundColor: "#EDED67" },
    REMOVE_TAG: { color: "#000", backgroundColor: "#EDED67" },
    SET_DEPARTMENT: { color: "#000", backgroundColor: "#40e6ba" },
    SEND_TRANSCRIPT: { color: "#ffffff", backgroundColor: "#4959DA" },
    SEND_SMS: { color: "#ffffff", backgroundColor: "#4959DA" },
    CREATE_TASK: { color: "#fff", backgroundColor: "#73adc5" },
    SUPPRESSION_ADD: { color: "#fff", backgroundColor: "#9d2126" },
    HOLIDAY_PLUS_GET_HOTELS: { color: "#fff", backgroundColor: "#82d1b2" },
    HOLIDAY_PLUS_GET_ROOMS: { color: "#fff", backgroundColor: "#82d1b2" },
    ZOHO_CREATE_RECORD: { color: "#fff", backgroundColor: "#82d1b2" },
    SUPPRESSION_REMOVE: { color: "#fff", backgroundColor: "#9d2126" },
    AKINON_SHOW_PRODUCTS: { color: "#000", backgroundColor: "#7aa8e0" },
    AKINON_FIND_PRODUCT: { color: "#000", backgroundColor: "#7aa8e0" },
    AKINON_ORDER_STATUS: { color: "#000", backgroundColor: "#7aa8e0" },
    AKINON_SELECT_ORDER: { color: "#000", backgroundColor: "#7aa8e0" },
    AKINON_SELECT_SIZE: { color: "#000", backgroundColor: "#7aa8e0" },
    AKINON_FIND_NEAREST_STOCK: { color: "#000", backgroundColor: "#7aa8e0" },
    AKINON_SHOW_DISCOUNT_CODES: { color: "#000", backgroundColor: "#7aa8e0" },
    AKINON_FIND_NEAREST_STORES: { color: "#000", backgroundColor: "#7aa8e0" },

    IDEASOFT_SELECT_ORDER: { color: "#dbdbdb", backgroundColor: "#f30879" },
    IDEASOFT_ORDER_STATUS: { color: "#dbdbdb", backgroundColor: "#f30879" },
    IDEASOFT_GET_MEMBER_INFO: { color: "#dbdbdb", backgroundColor: "#f30879" },
    IDEASOFT_PRODUCT_SEARCH: { color: "#dbdbdb", backgroundColor: "#f30879" },

    TSOFT_ORDER_STATUS: { color: "#3b3735", backgroundColor: "#C27041" },
    TSOFT_SELECT_ORDER: { color: "#3b3735", backgroundColor: "#C27041" },
    TICIMAX_V2_ORDER_STATUS: { color: "#fff", backgroundColor: "#757f94" },
    TICIMAX_V2_SELECT_ORDER: { color: "#fff", backgroundColor: "#757f94" },

    GET_LOCATION: { color: "#000", backgroundColor: "#7aa8e0" },
    SUCCESS: { color: "#00C800", backgroundColor: "#fff" },
    FAILURE: { color: "#FF0000", backgroundColor: "#fff" },
    SHOPIFY_SHOW_PRODUCTS: { color: "#000", backgroundColor: "#7aa8e0" },
    SHOPIFY_PRODUCT_AVAILABILITY: { color: "#000", backgroundColor: "#7aa8e0" },
    SHOPIFY_ORDER_STATUS: { color: "#000", backgroundColor: "#7aa8e0" },
    PROBEL_SELECT_BRANCH: { color: "#000", backgroundColor: "#cddc39" },
    PROBEL_SELECT_CLINIC: { color: "#000", backgroundColor: "#cddc39" },
    PROBEL_SELECT_DAY: { color: "#000", backgroundColor: "#cddc39" },
    PROBEL_SELECT_HOUR: { color: "#000", backgroundColor: "#cddc39" },
    PROBEL_MAKE_APPOINTMENT: { color: "#000", backgroundColor: "#cddc39" },
    PROBEL_CANCEL_APPOINTMENT: { color: "#000", backgroundColor: "#cddc39" },
    PROBEL_GET_PATIENT_TOKEN: { color: "#000", backgroundColor: "#cddc39" },
    PROBEL_SELECT_APPOINTMENT: { color: "#000", backgroundColor: "#cddc39" },
    SEND_MAIL: { color: "#ffffff", backgroundColor: "#ff7a1f" },
    CREATE_EVENT: { color: "#ffffff", backgroundColor: "#033c7c" },
    CREATE_RESERVATION: { color: "#ffffff", backgroundColor: "#235603" },
    RESERVATION_SELECT_TIME: { color: "#ffffff", backgroundColor: "#235603" },
    RESERVATION_SELECT_DAY: { color: "#ffffff", backgroundColor: "#235603" },
    RESERVATION_OPEN_URL: { color: "#ffffff", backgroundColor: "#235603" },
    RESERVATION_EVENT_LIST: { color: "#ffffff", backgroundColor: "#235603" },

    B2CARGO_LOGIN_USER: { color: "#fff", backgroundColor: "#ec630d" },
    B2CARGO_PRODUCT_STATUS: { color: "#fff", backgroundColor: "#ec630d" },
    SEND_WP_BUSINESS_MESSAGE: { color: "#fff", backgroundColor: "#4ee82f" },
    INSTAGRAM_COMMENT_REPLY: { color: "#fff", backgroundColor: "#833AB4" },
    INSTAGRAM_COMMENT_DELETE: { color: "#fff", backgroundColor: "#833AB4" },
    INSTAGRAM_COMMENT_SHOW: { color: "#fff", backgroundColor: "#833AB4" },
    INSTAGRAM_COMMENT_HIDE: { color: "#fff", backgroundColor: "#833AB4" },
    INSTAGRAM_COMMENT_REPLY_AS_PRIVATE: { color: "#fff", backgroundColor: "#833AB4" },
    INSTAGRAM_SEND_MESSAGE: { color: "#fff", backgroundColor: "#833AB4" },
    MESSENGER_SEND_MESSAGE: { color: "#fff", backgroundColor: "#0c9cf5" },
    META_SEND_CAPI_EVENT: { color: "#fff", backgroundColor: "#674ea7" },
    AI_MENU_FLOW: { color: "#fff", backgroundColor: "#4ee82f" },
    TABLE_CREATE_RECORD: { color: "#fff", backgroundColor: "#ec630d" },
    TABLE_DELETE_RECORD: { color: "#fff", backgroundColor: "#ec630d" },
    TABLE_UPDATE_RECORD: { color: "#fff", backgroundColor: "#ec630d" },
    TABLE_FIND_RECORD: { color: "#fff", backgroundColor: "#ec630d" },
    TABLE_FIND_RECORDS: { color: "#fff", backgroundColor: "#ec630d" },

    TAVILY_WEB_SEARCH: { color: "#fff", backgroundColor: "#ec630d" },
    OPENAI_WEB_SEARCH: { color: "#fff", backgroundColor: "#ec630d" },
    IKAS_GET_MEMBER_INFO: { color: "#000", backgroundColor: "#dcfb6e" },
    IKAS_SELECT_ORDER: { color: "#000", backgroundColor: "#dcfb6e" },
    IKAS_ORDER_STATUS: { color: "#000", backgroundColor: "#dcfb6e" },
    
    RUN_JAVASCRIPT: { color: "#fff", backgroundColor: "#ff6b35" },
    
    CACHE_WRITE: { 
        color: "#fff", 
        background: "linear-gradient(90deg, #8e24aa 0%, #7c4dff 100%)" 
    },
    CACHE_READ: { 
        color: "#fff", 
        background: "linear-gradient(90deg, #7b1fa2 0%, #6a1b9a 100%)" 
    },
    CACHE_EXTEND: { 
        color: "#fff", 
        background: "linear-gradient(90deg, #512da8 0%, #3949ab 100%)" 
    },
    CACHE_DELETE: { 
        color: "#fff", 
        background: "linear-gradient(90deg, #ab47bc 0%, #ec407a 100%)" 
    },
    
    CUSTOM_BLOCK: { 
        color: "#fff", 
        background: "linear-gradient(90deg, #7c4dff 0%, #4fc3f7 100%)"
    },
};

export const Payloads = Object.freeze({
    BOT_RESPONSE: {
        default: [
            {
                id: generateRandomId(),
                type: "TEXT",
                delay: 2,
                text: "", //attribute may contains {{name}}
                filters: {
                    operator: "or",
                    items: [], ////{rule,attribute,value}
                },
            },
        ],
        TEXT: {
            id: generateRandomId(),
            type: "TEXT",
            delay: 2,
            text: "", //attribute may contains
            filters: {
                operator: "or",
                items: [], ////{rule,attribute,value}
            },
        },
        RANDOM_TEXT: {
            id: generateRandomId(),
            type: "RANDOM_TEXT",
            delay: 2,
            texts: ["", ""], //attribute may contains for each
            filters: {
                operator: "or",
                items: [], ////{rule,attribute,value}
            },
        },
        AI_RANDOM_TEXT: {
            id: generateRandomId(),
            type: "AI_RANDOM_TEXT",
            delay: 2,
            texts: ["", ""], //attribute may contains for each
            prompt: "Aşağıdaki ifadelere benzeyen farklı ve rastgele bir cevap üret. Aşağıdaki ifadeler hangi dilde yazıldı ise cevap da o dilde yazılmalıdır.",
            filters: {
                operator: "or",
                items: [], ////{rule,attribute,value}
            },
        },
        AI_IMAGE: {
            id: generateRandomId(),
            delay: 1,
            type: "AI_IMAGE",
            prompt: "Başarılı bir şekilde işlemin tamamlandığını gösteren bir resim üret. Balonlar ve konfetiler ile birlikte.",
        },
        PRIVATE_MESSAGE: {
            id: generateRandomId(),
            type: "PRIVATE_MESSAGE",
            delay: 2,
            text: "",
            filters: {
                operator: "or",
                items: [],
            },
        },
        IMAGE: {
            id: generateRandomId(),
            type: "IMAGE",
            imageUrl: null,
            assetId: null,
            delay: 2,
            mode: "static", //static|dynamic,
            filters: {
                operator: "or",
                items: [], ////{rule,attribute,value}
            },
        },
        FILE: {
            id: generateRandomId(),
            type: "FILE",
            fileUrl: null,
            assetId: null,
            delay: 2,
            filters: {
                operator: "or",
                items: [], ////{rule,attribute,value}
            },
        },
        GALLERY: {
            id: generateRandomId(),
            type: "GALLERY",
            delay: 2,
            cards: [
                {
                    id: generateRandomId(),
                    imageUrl: null,
                    assetId: null,
                    title: null, //attribute may contains
                    description: null, //attribute may contains
                    buttons: [
                        {
                            id: generateRandomId(),
                            title: "Button", //attribute may contains
                            type: "SEND_MESSAGE",
                            payload: {},
                            actions: [], //{id:"",type: "SET_ATTRIBUTE", payload: {attribute:"custom",value:1} },//attribute may contains
                        },
                    ],
                },
            ],
            filters: {
                operator: "or",
                items: [], ////{rule,attribute,value}
            },
        },
        BUTTON: {
            id: generateRandomId(),
            type: "BUTTON",
            delay: 2,
            message: "", //attribute may contains
            buttons: [
                {
                    id: generateRandomId(),
                    title: "Button",
                    type: "SEND_MESSAGE",
                    payload: {},
                    actions: [], //{type: "SET_ATTRIBUTE", payload: {attribute:"custom",value:1} },//attribute may contains
                },
            ],
            filters: {
                operator: "or",
                items: [], ////{rule,attribute,value}
            },
            whatsappListSettings: {
                globalButtonTitle: "",
                sectionTitle: "",
                sectionSubTitle: "",
                footer: "",
            },
        },
        QUICK_REPLY: {
            id: generateRandomId(),
            type: "QUICK_REPLY",
            delay: 2,
            message: "", //attribute may contains
            buttons: [
                {
                    id: generateRandomId(),
                    title: "Button",
                    type: "SEND_MESSAGE",
                    payload: {},
                    actions: [], //{type: "SET_ATTRIBUTE", payload: {attribute:"custom",value:1} },//attribute may contains
                },
            ],
            filters: {
                operator: "or",
                items: [], ////{rule,attribute,value}
            },
            whatsappListSettings: {
                globalButtonTitle: "",
                sectionTitle: "",
                sectionSubTitle: "",
                footer: "",
            },
        },
        DYNAMIC_BUTTON: {
            id: generateRandomId(),
            type: "DYNAMIC_BUTTON",
            delay: 2,
            message: "", //attribute may contains
            buttonTemplate: {
                id: generateRandomId(),
                title: "{{title}}",
                type: "SEND_MESSAGE",
                payload: {},
                actions: [], //{type: "SET_ATTRIBUTE", payload: {attribute:"custom",value:1} },//attribute may contains
            },
            dataSource: "{{product_list}}",
        },
        DYNAMIC_QUICK_REPLY: {
            id: generateRandomId(),
            type: "DYNAMIC_QUICK_REPLY",
            delay: 2,
            message: "", //attribute may contains
            buttonTemplate: {
                id: generateRandomId(),
                title: "{{title}}",
                type: "SEND_MESSAGE",
                payload: {},
                actions: [], //{type: "SET_ATTRIBUTE", payload: {attribute:"custom",value:1} },//attribute may contains
            },
            dataSource: "{{product_list}}",
        },
    },
    AI_BOT_RESPONSE: {
        default: {
            prompt: "",
        },
    },
    AI_CLASSIFICATION: {
        default: {
            message: "{{message}}",
            imageUrl: "",
            tags: [],
            mode: "text",
        },
    },
    USER_INPUT: {
        default: {
            keywords: [""],
            inputs: [""],
            triggerFromAnywhere: false,
        },
    },
    TAG_CHAT: {
        default: {
            tags: [],
        },
    },
    REMOVE_TAG: {
        default: {
            tags: [],
        },
    },
    SET_DEPARTMENT: {
        default: {
            method: "static",
            departmentId: null,
        },
    },
    WEBHOOK: {
        default: {
            webhookId: null,
        },
    },
    ATTACHMENT_INPUT: {
        default: {
            fileType: "file",
            alias: "fileURL",
        },
    },
    GO_TO_STEP: {
        default: {
            blockId: null,
        },
    },
    ADD_TO_SEGMENT: {
        default: {
            segmentId: undefined,
        },
    },
    REMOVE_FROM_SEGMENT: {
        default: {
            segmentId: undefined,
        },
    },
    SET_ATTRIBUTE: {
        default: [
            {
                attribute: "", //attribute may contains
                value: "",
            },
        ],
    },
    QUESTION: {
        default: [
            {
                id: generateRandomId(),
                delay: 2,
                questions: ["", ""],
                validation: null,
                set: null,
                onFailure: "go_to_failure",
                askWhenInvalid: "until_filled",
            },
        ],
    },
    FILTER: {
        default: {
            operator: "or",
            groups: [
                {
                    id: generateRandomId(),
                    operator: "or",
                    filters: [], //{rule,attribute,value}
                },
            ],
        },
    },
    AKINON_ORDER_STATUS: {
        default: {
            orderId: "{{akinon_order_id}}",
        },
    },
    AKINON_SELECT_ORDER: {
        default: {
            akinonUserId: "{{akinon_user_id}}",
        },
    },
    AKINON_SELECT_SIZE: {
        default: {
            productId: "{{akinon_product_id}}",
        },
    },
    AKINON_FIND_PRODUCT: {
        default: {
            sku: "{{akinon_sku}}",
        },
    },
    AKINON_SHOW_DISCOUNT_CODES: {
        default: {
            email: "{{akinon_user_email}}",
        },
    },
    AKINON_FIND_NEAREST_STOCK: {
        default: {
            sku: "{{akinon_sku}}",
            latitude: "{{akinon_latitude}}",
            longitude: "{{akinon_longitude}}",
        },
    },
    AKINON_FIND_NEAREST_STORES: {
        default: {
            latitude: "{{akinon_latitude}}",
            longitude: "{{akinon_longitude}}",
        },
    },
    GET_LOCATION: {
        default: {
            setLatitude: "latitude",
            setLongitude: "longitude",
            initialCountry: "TR",
            initialState: "34",
            initialCity: null,
            delay: 2,
            message: "Lütfen konumunuzu paylaşınız.",
        },
    },

    IDEASOFT_SELECT_ORDER: {
        default: {
            ideasoftUserId: "{{ideasoft_user_id}}",
        },
    },
    IDEASOFT_ORDER_STATUS: {
        default: {
            orderId: "{{ideasoft_order_id}}",
        },
    },
    IDEASOFT_PRODUCT_SEARCH: {
        default: {
            searchTerm: "{{product_name}}",
        },
    },
    TSOFT_ORDER_STATUS: {
        default: {
            orderId: "{{tsoft_order_id}}",
        }
    },
    TICIMAX_V2_ORDER_STATUS: {
        default: {
            orderId: "{{ticimax_order_id}}",
        },
    },
    PROBEL_SELECT_BRANCH: {
        default: {
            hospitalBranchId: "{{probel_sube_kodu}}",
        },
    },
    RESERVATION_SELECT_DAY: {
        default: {
            reservationPlanId: "{{reservation_plan_id}}",
        },
    },
    RESERVATION_SELECT_TIME: {
        default: {
            reservationSelectedDay: "{{reservation_day}}",
            reservationPlanId: "{{reservation_plan_id}}",
        },
    },
    PROBEL_SELECT_CLINIC: {
        default: {
            hospitalBranchId: "{{probel_sube_kodu}}",
            branchId: "{{probel_brans_kodu}}",
        },
    },
    PROBEL_SELECT_DAY: {
        default: {
            hospitalBranchId: "{{probel_sube_kodu}}",
            clinicCode: "{{probel_poliklinik_kodu}}",
        },
    },
    PROBEL_SELECT_HOUR: {
        default: {
            clinicCode: "{{probel_poliklinik_kodu}}",
            date: "{{probel_randevu_tarihi}}",
            showAMHours: false,
            showPMHours: false,
        },
    },
    PROBEL_MAKE_APPOINTMENT: {
        default: {
            patientToken: "{{probel_hasta_token}}",
            appointmentId: "{{probel_randevu_id}}",
        },
    },
    PROBEL_CANCEL_APPOINTMENT: {
        default: {
            patientToken: "{{probel_hasta_token}}",
            appointmentId: "{{probel_randevu_id}}",
        },
    },
    PROBEL_GET_PATIENT_TOKEN: {
        default: {
            patientToken: "{{probel_hasta_token}}",
            identityType: "{{probel_kimlik_tipi}}",
            identityNumber: "{{probel_kimlik_no}}",
            name: "{{probel_hasta_adi}}",
            surname: "{{probel_hasta_soyadi}}",
            gender: "{{probel_hasta_cinsiyet}}",
            birthDay: "{{probel_hasta_dogum_tarihi}}",
            phoneNumber: "{{probel_hasta_telefon}}",
        },
    },
    PROBEL_SELECT_APPOINTMENT: {
        default: {
            patientToken: "{{probel_hasta_token}}",
        },
    },
    TSOFT_SELECT_ORDER: {
        default: {
            customerEmail: "{{tsoft_customer_email}}",
        }
    },
    TICIMAX_V2_SELECT_ORDER: {
        default: {
            customerContact: "{{phone}}",
        },
    },
    IKAS_GET_MEMBER_INFO: {
        default: {
            customerEmail: "{{ikas_customer_email}}",
        },
    },
    IKAS_SELECT_ORDER: {
        default: {
            customerId: "{{ikas_customer_id}}",
        },
    },
    IKAS_ORDER_STATUS: {
        default: {
            orderNumber: "{{ikas_order_number}}",
        },
    },
    INSERT_TO_SYSTEM_PROMPT: {
        default: {
            message: "Sistem promptuna eklenecek mesajınızı buraya yazınız.",
        },
    },
    RUN_JAVASCRIPT: {
        default: {
            code: `// Burada kod yazabilirsiniz
// İşlevin sonucunu döndürmelisiniz

async function main() {
  // Chatbot attribute okuma
  const userName = chatbot.readAttribute('name', 'Misafir');
  const userEmail = chatbot.readAttribute('email', '');
  
  // Mesaj gönderme
  await chatbot.sendMessage(\`Merhaba \${userName}!\`, 'text');
  
  // Attribute güncelleme
  chatbot.setAttributes({
    processed: true,
    process_date: moment().format('YYYY-MM-DD HH:mm:ss')
  });
  
  // İşlem sonucunu döndürün
  return {
    userName,
    userEmail,
    processedAt: moment().toISOString()
  };
}`,
            exampleResult: {
                success: true,
                result: {
                    userName: "Örnek Kullanıcı",
                    userEmail: "ornek@example.com",
                    processedAt: "2024-01-01T00:00:00.000Z"
                }
            },
        },
    },
    CUSTOM_BLOCK: {
        default: {
            customBlockId: null,
            versionId: null, // null = "latest"
            parameters: {},
            exampleResult: null,
        },
    },
});

export const IS_CHARTS_PUBLIC = true;
